import React from "react";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { useTheme } from "@mui/material/styles";

const AutocompleteCustomized = ({
  label,
  options,
  onChange,
  value = null,
  allowTyping = true,
  height = 40,
  width = null,
  labelSize = 15,
  error = null,
  placeholder,
  ...restProps
}) => {
  const theme = useTheme();

  const borderStyles = {
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        border: error ? "1px solid red" : "1px solid gray",
      },
      "&:hover fieldset": {
        border: error ? "1px solid red" : "1px solid gray",
      },
      "&.Mui-focused fieldset": {
        border: error ? "1px solid red" : "1px solid gray",
      },
    },
  };

  const selectedOption = value
    ? options?.find((option) => option.value === value.value)
    : null;

  const getOptionLabel = (option) => {
    if (option && "label" in option) {
      return option?.label;
    }
    return "";
  };

  const isOptionEqualToValue = (option, value) => {
    return option.value === value.value;
  };

  return (
    <Box>
      <Typography
        gutterBottom
        color="primary.main"
        style={{
          marginLeft: 7,
          fontSize: `${labelSize}px`,
        }}
      >
        {label}
      </Typography>
      <Autocomplete
        fullWidth={width === null}
        sx={{
          width: width !== null ? `${width}px` : undefined,
        }}
        options={options}
        onChange={(event, newValue) => onChange(newValue)}
        value={selectedOption || null}
        getOptionLabel={getOptionLabel}
        isOptionEqualToValue={isOptionEqualToValue}
        renderInput={(params) => (
          <TextField
            fullWidth
            placeholder={placeholder}
            {...params}
            {...restProps}
            InputProps={{
              ...params.InputProps,
              sx: {
                alignContent: "center",
                color: theme.palette.text.primary,
                height: `${height}px`,
                "& .MuiSvgIcon-root": {
                  color: theme.palette.primary.main,
                },
                backgroundColor: "#F6F6F6",
                ...borderStyles,
              },
            }}
            sx={{
              backgroundColor: "white",
              borderRadius: 2,
              "& .MuiInputBase-root": {
                color: theme.palette.text.primary,
              },
              "& .MuiInputLabel-root": {
                color: theme.palette.text.primary,
              },
              ...borderStyles,
            }}
          />
        )}
        {...restProps}
      />
    </Box>
  );
};

export default AutocompleteCustomized;
